// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";

export interface RequestRmaConfirmationOrderHeaderStyles {
    container?: InjectableCss;
    returnRmaOrderHeaderNumber?: TypographyPresentationProps;
}

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export const requestRmaConfirmationOrderHeaderStyles: RequestRmaConfirmationOrderHeaderStyles = {};

const styles = requestRmaConfirmationOrderHeaderStyles;

// this widget specifies the RequestRmaConfirmation Number
const RequestRmaConfirmationOrderHeader: FC<Props> = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.webOrderNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="rmaConfirmation_orderHeader">
            <Typography {...styles.returnRmaOrderHeaderNumber}>
                {`${translate("Your return request confirmation is")} ${order.webOrderNumber}`}
            </Typography>
            {/* authored rich content under the header for rma confirmation which is displayed the same on RmaConfirmation Email */}
            {siteMessage("Custom_RmaConfirmationRichContent")}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RequestRmaConfirmationOrderHeader,
    definition: {
        allowedContexts: ["RequestRmaSuccessPage"],
        group: "Request Rma Confirmation" as any,
    },
};

export default widgetModule;
